import { useTranslation } from "react-i18next";

import card1 from "../../assets/images/playing/card1.png";
import card2 from "../../assets/images/playing/card2.png";
import magicPen from "../../assets/images/playing/magicPen.png";
import magicPenJP from "../../assets/images/playing/magicPen-JP.png";
import mickeyPen from "../../assets/images/playing/mickeyPen.png";
import playmate from "../../assets/images/playing/playmate.png";
import qaCardsEtab from "../../assets/images/playing/qaCards-etab.png";
import qaCardsEtabJP from "../../assets/images/playing/qaCards-etab-JP.png";
import bubble from "../../assets/images/shared/bubble.png";
import talkAlongCards from "../../assets/images/playing/talkAlongCards.png";
import talkAlongCardsJP from "../../assets/images/playing/talkAlongCards-JP.png";
import Text from "../../components/ui/Text";
import useStore from "../../hooks/store/useStore";
import cn from "../../utils/cn";
import BookButton from "../bookDemo/BookButton";
import MenuCard from "./components/MenuCard";

export default function Playing() {
  const { t } = useTranslation();
  const { userInformation } = useStore((state) => state.user);
  const { market } = userInformation || {};

  return (
    <div className="relative w-full p-5">
      <Text className="mb-1 text-center text-[22px]">{t("playing")}</Text>
      <Text normal className="text-center">
        {t("playingDescription")}
      </Text>

      <div className="flex flex-col gap-3 px-8 py-6">
        <MenuCard
          text={t("magicPen")}
          url={market === "JP" ? magicPenJP : magicPen}
          border="border-lightGreen2"
          dataIndex={0}
        >
          <img
            src={mickeyPen}
            alt="mickeyPen"
            className="absolute bottom-1 right-1 w-12"
          />
        </MenuCard>

        <MenuCard
          text={t("talkAlongCards")}
          url={market === "JP" ? talkAlongCardsJP : talkAlongCards}
          border="border-lightBlue2"
          dataIndex={1}
        >
          <img
            src={card1}
            alt="card1"
            className={cn(
              "absolute right-[14px] w-[82px]",
              market === "JP" ? "bottom-9" : "bottom-4",
            )}
          />
          <img
            src={playmate}
            alt="playmate"
            className={cn(
              "absolute right-3 w-[90px]",
              market === "JP" ? "bottom-7" : "bottom-2",
            )}
          />
        </MenuCard>

        <MenuCard
          text={t("qaCards")}
          url={market === "JP" ? qaCardsEtabJP : qaCardsEtab}
          border="border-yellow2"
          dataIndex={2}
        >
          <img
            src={card2}
            alt="card2"
            className="absolute bottom-5 right-[18px] w-20"
          />
          <img
            src={playmate}
            alt="playmate"
            className="absolute bottom-2 right-3 w-[90px]"
          />
        </MenuCard>
      </div>

      <img
        src={bubble}
        alt="bubble"
        className="floating absolute right-2 top-16 size-8"
      />
      <img
        src={bubble}
        alt="bubble"
        className="floating absolute left-4 top-60 size-6"
        style={{ animationDelay: "0.7s" }}
      />
      <img
        src={bubble}
        alt="bubble"
        className="floating absolute -left-4 bottom-12 size-10"
        style={{ animationDelay: "1.3s" }}
      />

      <BookButton sourcePage="Playing" />
    </div>
  );
}
